module.exports = __webpack_public_path__ + "static/media/pic_7.6516acf6.jpg";